import { render, staticRenderFns } from "./OrderItemAmenity.vue?vue&type=template&id=58d03253&scoped=true&"
import script from "./OrderItemAmenity.vue?vue&type=script&lang=js&"
export * from "./OrderItemAmenity.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemAmenity.vue?vue&type=style&index=0&id=58d03253&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d03253",
  null
  
)

export default component.exports